'use client';

import { swal } from '@/lib/sweetalert';
import { UrlShare as CommonUrlShare, type UrlShareProps } from '@monorepo/common';

function UrlShare({ url, twitterShareText }: UrlShareProps) {
  const handleCopySuccess = async () => {
    await swal.messages({ messages: ['URLをコピーしました。'] });
  };

  return <CommonUrlShare url={url} twitterShareText={twitterShareText} onCopySuccess={handleCopySuccess} />;
}

export default UrlShare;
